import {
    addCursorHighlights,
    removeCursorHighlights,
} from './cursorHighlightControls'
import {
    getQGRecordingState,
    getResizeMetaData,
    handleResizeEvent,
} from '../../background/services'
import {
    deleteRecControls,
    enablePauseControls,
    enableProcessingState,
    injectRecControls,
} from './injectRecControls'
import { debounce } from 'lodash'
import { QG_STATE } from '../../types/quickGuidde'

export const qgStatusObserver = orgData => {
    const addResizeEvent = () => {
        window.addEventListener('resize', windowReSizeListener)
    }
    const removeResizeEvent = () => {
        window.removeEventListener('resize', windowReSizeListener)
    }
    // Checking if the recording is already in progress
    getQGRecordingState(({ state }) => {
        if (state === QG_STATE.RECORDING || state === QG_STATE.PAUSED) {
            injectRecControls(
                'quickguidde',
                orgData,
                false,
                state as QG_STATE.RECORDING | QG_STATE.PAUSED
            ).then(() => {
                addResizeEvent()
                addCursorHighlights()
            })
        } else {
            removeResizeEvent()
        }
    })

    const windowReSizeListener = debounce(() => {
        getResizeMetaData(res => {
            const temp = { ...res.resizeMetaData }
            temp.resizeMetaData.newWindowDimensions = {
                innerHeight: window?.innerHeight,
                innerWidth: window?.innerWidth,
                outerHeight: window.outerHeight,
                outerWidth: window.outerWidth,
            }
            handleResizeEvent(temp)
        })
    }, 1000)

    // On recording state change
    chrome?.runtime?.onMessage?.addListener(async msg => {
        if (msg.action === 'QG_STATE_CHANGED') {
            const status = msg?.response?.newState

            if (status === QG_STATE.RECORDING) {
                const wasPaused = msg?.response?.prevState === QG_STATE.PAUSED
                if (wasPaused) {
                    enablePauseControls(status)
                } else {
                    await injectRecControls(
                        'quickguidde',
                        orgData,
                        true,
                        status
                    )
                    addCursorHighlights()
                    addResizeEvent()
                }
            } else if (status === QG_STATE.PAUSED) {
                enablePauseControls(status)
            } else if (status === QG_STATE.PROCESSING) {
                removeCursorHighlights()
                enableProcessingState()
                removeResizeEvent()
            } else {
                // Recording is finished
                deleteRecControls()
                removeResizeEvent()
            }
        }
        return true
    })
}
